@if (showToast) {
  <plugins-notice
    type="toast-float"
    [color]="data.color ?? ''"
    (dismiss)="onClose()"
    [pluginsAnimation]="animations"
    (pluginsAnimationDone)="onAnimationDone($event)"
  >
    @let message = data.message | nl2br;
    @if (message) {
      <div [innerHTML]="message | dompurify"></div>
    }
  </plugins-notice>
}
